import type { BasicCustomMailRequiredItemOverrideInput, LangCode } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

import { QuestionEmailTemplateItem } from "../_shared/components/email-template-item";

import type { ProductDayTripPlanI18nFormModel } from "../../../../../../model";

type Props = {
	isEdited: boolean;
	hasError: boolean;
	hotelEmailAddress: string;
	atCreated: ForAutoGenerator<BasicCustomMailRequiredItemOverrideInput, "">;
	onSetAtCreatedForText: (value: string) => void;
	onSendTestEmailReservationCreated: ({ lang, email }: { lang: LangCode; email: string }) => Promise<void>;
	atUpdated: ForAutoGenerator<BasicCustomMailRequiredItemOverrideInput, "">;
	onSetAtUpdatedForText: (value: string) => void;
	onSendTestEmailReservationUpdated: ({ lang, email }: { lang: LangCode; email: string }) => Promise<void>;
	atCanceled: ForAutoGenerator<BasicCustomMailRequiredItemOverrideInput, "">;
	onSetAtCanceledForText: (value: string) => void;
	onSendTestEmailReservationCanceled: ({ lang, email }: { lang: LangCode; email: string }) => Promise<void>;
	basicCustomMailSetting: ProductDayTripPlanI18nFormModel["QueryData"]["basicCustomMailSetting"];
	defaultPlanCustomMailSetting: ProductDayTripPlanI18nFormModel["QueryData"]["defaultPlanCustomMailSetting"];
	lang: LangCode;

	/** 基本メール設定の文言 */

	title?: string;
	guide?: string;
};

export const ForTriggerReservationEmailTemplates = ({
	isEdited,
	hasError,
	hotelEmailAddress,
	atCreated,
	onSetAtCreatedForText,
	onSendTestEmailReservationCreated,
	atUpdated,
	onSetAtUpdatedForText,
	onSendTestEmailReservationUpdated,
	atCanceled,
	onSetAtCanceledForText,
	onSendTestEmailReservationCanceled,
	basicCustomMailSetting,
	defaultPlanCustomMailSetting,
	lang,

	title: _title,
	guide: _guide,
}: Props) => {
	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title=""
			guide=""
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<div className="space-y-6">
					<QuestionEmailTemplateItem
						lang={lang}
						label={"予約成立時"}
						hotelEmailAddress={hotelEmailAddress}
						textValue={atCreated?.text.value}
						textErrorMessage={atCreated?.text.error}
						handleChangeText={onSetAtCreatedForText}
						sendTestEmail={onSendTestEmailReservationCreated}
						isOverride={defaultPlanCustomMailSetting?.atCreated?.override ?? false}
						basicCustomMailSetting={basicCustomMailSetting?.atCreated}
					/>
					<QuestionEmailTemplateItem
						lang={lang}
						label={"予約が変更された時"}
						hotelEmailAddress={hotelEmailAddress}
						textValue={atUpdated?.text.value}
						textErrorMessage={atUpdated?.text.error}
						handleChangeText={onSetAtUpdatedForText}
						sendTestEmail={onSendTestEmailReservationUpdated}
						isOverride={defaultPlanCustomMailSetting?.atUpdated?.override ?? false}
						basicCustomMailSetting={basicCustomMailSetting?.atUpdated}
					/>
					<QuestionEmailTemplateItem
						lang={lang}
						label={"予約がキャンセルされた時"}
						hotelEmailAddress={hotelEmailAddress}
						textValue={atCanceled?.text.value}
						textErrorMessage={atCanceled?.text.error}
						handleChangeText={onSetAtCanceledForText}
						sendTestEmail={onSendTestEmailReservationCanceled}
						isOverride={defaultPlanCustomMailSetting?.atCanceled?.override ?? false}
						basicCustomMailSetting={basicCustomMailSetting?.atCanceled}
					/>
				</div>
			}
		/>
	);
};

ForTriggerReservationEmailTemplates.displayName = "ForTriggerReservationEmailTemplates";
